import { takeEvery, select } from 'redux-saga/effects';
import { get, getOr } from 'lodash/fp';
import * as Sentry from '@sentry/browser';
import * as actions from './actions';

function* configScope() {
  try {
    const user = yield select(state => state.user.info);
    const {
      name: username,
      id,
      role,
    } = user;

    Sentry.configureScope((scope) => {
      scope.setUser({ username, id });
      scope.setTag('role', role);
    });
  } catch (error) {
    // Do nothing
  }
}


function reportError(error) {
  const { status, data, config } = error.response;

  if (status < 400 && status >= 500) {
    Sentry.captureMessage(error, {
      extra: {
        status,
        data,
        config,
      },
    });
  }
}

function reportStorageError(error) {
  Sentry.captureMessage(error);
}

function* onError(action) {
  const { error } = action.payload;

  yield configScope();

  if (get('response', error)) {
    reportError(error);
    return;
  }

  if (get('serverResponse_', error)) {
    reportStorageError(error);
    return;
  }

  if (getOr('', 'message', error) !== 'Network Error') {
    Sentry.captureException(error);
  }
}

export function* watchErrors() {
  yield takeEvery(actions.ERROR_OCCURED, onError);
}
